import { MyPageDataType } from '../type/MyPageData.type';

export const MyPageInitial: MyPageDataType = {
    schools: [],
    schoolsCount: 0,
    reviews: [],
    inquiries: [],
    inquiriesCount: 0,
}